<template>
  <div
    class="mt-4 border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden"
    :class="{ 'bg-primary-50 dark:bg-primary-900/20': dragOver }"
    @dragover.prevent="dragOver = true"
    @dragenter.prevent="dragOver = true"
    @dragleave="dragOver = false"
    @drop="onDrop">
    <button
      @click="expanded = !expanded"
      class="w-full flex items-center justify-between px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/30">
      <span>Unscheduled ({{ posts.length }})</span>
      <svg class="w-4 h-4 transition-transform" :class="{ 'rotate-180': expanded }" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
    </button>
    <div v-if="expanded && posts.length > 0" class="px-4 pb-3 flex flex-wrap gap-1.5">
      <CalendarPostPill
        v-for="post in posts"
        :key="post.id"
        :post="post"
        :color="getColor(post)"
        @click="$emit('click-post', $event)" />
    </div>
    <div v-if="expanded && posts.length === 0" class="px-4 pb-3 text-sm text-gray-400 dark:text-gray-500">
      No unscheduled posts. Drag a post here to unschedule it.
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CalendarPostPill from './calendar_post_pill.vue'

const props = defineProps({
  posts: { type: Array, default: () => []},
  campaignColors: { type: Map, default: () => new Map() }
})

const emit = defineEmits(['drop', 'click-post'])

const expanded = ref(true)
const dragOver = ref(false)

function getColor(post) {
  return props.campaignColors.get(post.gbp_campaign_id) || { bg: 'bg-gray-100', text: 'text-gray-800', dot: 'bg-gray-500', darkBg: 'dark:bg-gray-700', darkText: 'dark:text-gray-200' }
}

function onDrop(e) {
  dragOver.value = false
  try {
    const data = JSON.parse(e.dataTransfer.getData('application/json'))
    emit('drop', data.postId)
  } catch (_) {
    // ignore invalid drag data
  }
}
</script>
